import React from "react"
import classNames from "classnames"

import { useTranslation } from "@/locales"

import styles from "./index.module.less"

interface EndingProps {
    ending: number
    grade: number
    className?: string
    style?: React.CSSProperties
}

const Ending: React.FC<EndingProps> = (props) => {
    const { ending, grade, className, style } = props
    const { t } = useTranslation()

    return (
        <div
            className={classNames(styles.ending, className)}
            style={style}
            data-key={ending}
        >
            <div className={styles.difficulty}>{t("difficulty.normal")}</div>
            {grade ? <div className={styles.grade}>{grade}</div> : null}
        </div>
    )
}

export default Ending
